<template>
    <Modal v-if="recoveryCodes.length === 0" size="xl" @close="closeModal">
        <template #header>
            <div class="text-gray-600">Enable Authenticator App</div>
        </template>

        <template #body>
            <div class="w-full p-[26px]">
                <div
                    class="text-center text-sm font-medium text-gray-500 sm:text-left"
                >
                    Make your account safer in 3 Easy Steps:
                </div>
                <div
                    class="mt-9 flex flex-col justify-start border-b pb-6 sm:flex-row sm:pl-[46px]"
                >
                    <div class="flex items-center justify-center">
                        <svg
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0 32C0 7.70089 7.70088 0 31.9998 0C56.2991 0 64 7.70089 64 32C64 56.2991 56.2991 64 31.9998 64C7.70089 64 0 56.2991 0 32Z"
                                fill="url(#paint0_linear_3504_8317)"
                            />
                            <g filter="url(#filter0_d_3504_8317)">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M51.345 27.8364C50.9836 27.8364 50.6907 27.5415 50.6907 27.1777V27.1315C50.6907 16.7573 42.306 8.31731 31.9996 8.31731C28.176 8.31731 24.4999 9.47136 21.369 11.6548C21.2556 11.7341 21.1256 11.7721 20.997 11.7721C20.7895 11.7721 20.5854 11.6729 20.4583 11.4883C20.2525 11.1893 20.3266 10.7789 20.6236 10.5717C23.9746 8.23507 27.9084 7 31.9996 7C43.0277 7 51.9996 16.0309 51.9996 27.1315V27.1777C51.9996 27.5415 51.7065 27.8364 51.345 27.8364Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M32.0004 57C29.5843 57 27.222 56.5706 24.9795 55.7244C24.641 55.5965 24.4696 55.2167 24.5966 54.876C24.6951 54.6118 24.9446 54.4483 25.2095 54.4483C25.2858 54.4483 25.3634 54.4618 25.4392 54.4906C27.5344 55.2815 29.7418 55.6824 32.0004 55.6824C42.3069 55.6824 50.6916 47.2422 50.6916 36.8679V32.0683C50.6916 31.7045 50.9845 31.4097 51.3459 31.4097C51.7073 31.4097 52.0005 31.7045 52.0005 32.0683V36.8679C52.0005 47.9688 43.0285 57 32.0004 57Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M20.9234 53.4948C20.7939 53.4948 20.6632 53.4561 20.549 53.3755C15.1961 49.6062 12 43.4351 12 36.8679V27.1315C12.0002 22.2806 13.7384 17.5944 16.8947 13.9363C17.0242 13.7866 17.2062 13.7097 17.3891 13.7097C17.5412 13.7097 17.6942 13.7627 17.818 13.871C18.091 14.1096 18.12 14.5257 17.8829 14.8004C14.9334 18.2187 13.3092 22.598 13.3092 27.1315V36.8679C13.3092 43.0055 16.296 48.7731 21.2992 52.2963C21.5953 52.5045 21.6675 52.9152 21.4602 53.2135C21.3331 53.3966 21.13 53.4948 20.9234 53.4948Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M40.4374 50.5888C40.2237 50.5888 40.014 50.4834 39.8884 50.2897C39.6911 49.9848 39.7767 49.5766 40.0796 49.378C44.301 46.6093 46.8217 41.9327 46.8217 36.868V27.1315C46.8217 23.9379 45.8338 20.8923 43.9649 18.3242C43.7513 18.0306 43.8144 17.6185 44.1061 17.4034C44.2224 17.3175 44.3578 17.276 44.4922 17.276C44.6936 17.276 44.8924 17.3695 45.0207 17.5458C47.0549 20.3412 48.1304 23.6558 48.1304 27.1315V36.868C48.1304 42.3797 45.3879 47.469 40.7942 50.482C40.6837 50.5544 40.5601 50.5888 40.4374 50.5888Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M31.9995 53.1053C23.1051 53.1053 15.8691 45.8213 15.8691 36.868V31.2141C15.8691 30.8503 16.162 30.5552 16.5232 30.5552C16.8849 30.5552 17.1778 30.8503 17.1778 31.2141V36.868C17.1778 45.0949 23.827 51.7875 31.9995 51.7875C33.5789 51.7875 35.1332 51.5393 36.6191 51.0491C36.6869 51.0267 36.7557 51.0162 36.8233 51.0162C37.0984 51.0162 37.3544 51.1925 37.4449 51.4701C37.5574 51.8158 37.3703 52.1877 37.0267 52.3009C35.409 52.8348 33.7174 53.1053 31.9995 53.1053Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M16.5232 27.8257C16.162 27.8257 15.8691 27.5309 15.8691 27.1671V27.1315C15.8691 18.1784 23.1051 10.8944 31.9995 10.8944C35.6814 10.8944 39.2821 12.1756 42.139 14.5024C42.4199 14.7312 42.4633 15.1461 42.236 15.4289C42.1068 15.5897 41.9177 15.6731 41.727 15.6731C41.5824 15.6731 41.437 15.6253 41.3156 15.5266C38.6914 13.3889 35.3827 12.212 31.9995 12.212C23.827 12.212 17.1778 18.9048 17.1778 27.1315V27.1671C17.1778 27.5309 16.8849 27.8257 16.5232 27.8257Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M20.3924 32.7095C20.0312 32.7095 19.7383 32.4146 19.7383 32.0506V27.1317C19.7383 20.3259 25.2386 14.7893 31.9997 14.7893C38.7609 14.7893 44.2616 20.3259 44.2616 27.1317V27.1579C44.2616 27.5217 43.9682 27.8168 43.607 27.8168C43.2456 27.8168 42.9525 27.5217 42.9525 27.1579V27.1317C42.9525 21.0525 38.0392 16.1066 31.9997 16.1066C25.9602 16.1066 21.0469 21.0525 21.0469 27.1317V32.0506C21.0469 32.4146 20.7541 32.7095 20.3924 32.7095Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M31.9997 49.2106C25.2386 49.2106 19.7383 43.6738 19.7383 36.868V36.855C19.7383 36.4912 20.0312 36.203 20.3924 36.203C20.7541 36.203 21.0469 36.5044 21.0469 36.868C21.0469 42.9474 25.9602 47.8931 31.9997 47.8931C38.0392 47.8931 42.9525 42.9474 42.9525 36.868V31.9626C42.9525 31.5988 43.2456 31.3037 43.607 31.3037C43.9682 31.3037 44.2616 31.5988 44.2616 31.9626V36.868C44.2616 43.6738 38.7609 49.2106 31.9997 49.2106Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M33.2859 45.2091C32.9718 45.2091 32.6947 44.981 32.6411 44.659C32.5815 44.3001 32.822 43.9608 33.1783 43.9004C36.6002 43.3242 39.0837 40.3665 39.0837 36.868V27.1316C39.0837 23.1998 35.9059 20.001 31.9999 20.001C28.0941 20.001 24.9163 23.1998 24.9163 27.1316V36.868C24.9163 39.5748 26.4084 42.0153 28.8106 43.2368C29.1333 43.4008 29.2626 43.7973 29.0999 44.1221C28.9848 44.3514 28.7543 44.4837 28.5153 44.4837C28.4158 44.4837 28.3151 44.4608 28.2204 44.4127C25.3751 42.966 23.6074 40.0751 23.6074 36.868V27.1316C23.6074 22.4734 27.3725 18.6837 31.9999 18.6837C36.6278 18.6837 40.3926 22.4734 40.3926 27.1316V36.868C40.3926 41.0129 37.4494 44.5168 33.3944 45.2C33.3581 45.2062 33.3215 45.2091 33.2859 45.2091Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M32.0001 41.4217C29.5062 41.4217 27.4766 39.379 27.4766 36.8681V27.1316C27.4766 24.621 29.5062 22.5785 32.0001 22.5785C34.4945 22.5785 36.5236 24.621 36.5236 27.1316V27.1478C36.5236 27.5116 36.2307 27.7986 35.8691 27.7986C35.5079 27.7986 35.215 27.4954 35.215 27.1316C35.215 25.3474 33.7729 23.8958 32.0001 23.8958C30.2276 23.8958 28.7857 25.3474 28.7857 27.1316V36.8681C28.7857 38.6526 30.2276 40.1041 32.0001 40.1041C33.7729 40.1041 35.215 38.6526 35.215 36.8681V32.1556C35.215 31.7916 35.5079 31.4967 35.8691 31.4967C36.2307 31.4967 36.5236 31.7916 36.5236 32.1556V36.8681C36.5236 39.379 34.4945 41.4217 32.0001 41.4217Z"
                                    fill="#FFC000"
                                />
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M31.9998 37.5269C31.6386 37.5269 31.3457 37.2318 31.3457 36.868V27.1316C31.3457 26.7677 31.6386 26.4729 31.9998 26.4729C32.3612 26.4729 32.6544 26.7677 32.6544 27.1316V36.868C32.6544 37.2318 32.3612 37.5269 31.9998 37.5269Z"
                                    fill="#FFC000"
                                />
                            </g>
                            <defs>
                                <filter
                                    id="filter0_d_3504_8317"
                                    x="6"
                                    y="1"
                                    width="52"
                                    height="62"
                                    filterUnits="userSpaceOnUse"
                                    color-interpolation-filters="sRGB"
                                >
                                    <feFlood
                                        flood-opacity="0"
                                        result="BackgroundImageFix"
                                    />
                                    <feColorMatrix
                                        in="SourceAlpha"
                                        type="matrix"
                                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                        result="hardAlpha"
                                    />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation="3" />
                                    <feColorMatrix
                                        type="matrix"
                                        values="0 0 0 0 1 0 0 0 0 0.752941 0 0 0 0 0 0 0 0 0.72 0"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in2="BackgroundImageFix"
                                        result="effect1_dropShadow_3504_8317"
                                    />
                                    <feBlend
                                        mode="normal"
                                        in="SourceGraphic"
                                        in2="effect1_dropShadow_3504_8317"
                                        result="shape"
                                    />
                                </filter>
                                <linearGradient
                                    id="paint0_linear_3504_8317"
                                    x1="-1.76528e-05"
                                    y1="0.000268449"
                                    x2="64"
                                    y2="64.0003"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#374151" />
                                    <stop
                                        offset="1"
                                        stop-color="#374151"
                                        stop-opacity="0.82"
                                    />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div
                        class="mt-5 flex flex-col items-center justify-center text-center sm:mt-0 sm:items-start sm:pl-16 sm:text-left"
                    >
                        <p class="text-base font-medium text-gray-800">
                            Download an authenticator App
                        </p>
                        <p class="mt-2 text-sm text-gray-500 sm:mt-0">
                            Download and Install an
                            <a
                                target="_blank"
                                class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                                href="https://authy.com/download/"
                                >Authenticator App</a
                            >
                            for your phone or tablet.
                        </p>
                    </div>
                </div>

                <div
                    class="mt-[26px] flex flex-col items-center justify-start border-b pb-6 sm:flex-row"
                >
                    <div class="flex items-center justify-center">
                        <transition
                            enter-active-class="transition duration-1000 ease-out transform"
                            enter-from-class="scale-95 opacity-0"
                            enter-to-class="scale-100 opacity-100"
                            leave-active-class="transition duration-75 ease-in transform"
                            leave-from-class="scale-100 opacity-100"
                            leave-to-class="scale-95 opacity-0"
                        >
                            <div
                                v-if="paringCodes.qrCode"
                                class="h-[150px] w-[150px] rounded-[6px] border p-[17px]"
                                v-html="paringCodes.qrCode"
                            ></div>
                        </transition>

                        <div
                            v-if="!paringCodes.qrCode"
                            class="flex h-[150px] w-[150px] items-center justify-center rounded-[6px] border p-[17px]"
                        >
                            <svg
                                class="h-6 w-6 animate-spin text-gray-600"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    class="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="4"
                                ></circle>
                                <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                            </svg>
                        </div>
                    </div>

                    <div
                        class="mt-5 flex max-w-sm flex-col items-center justify-center text-center sm:mt-0 sm:max-w-[430px] sm:items-start sm:pl-6 sm:text-left"
                    >
                        <p class="text-base font-medium text-gray-800">
                            Scan the QR Code
                        </p>
                        <p class="mt-2 text-sm text-gray-500 sm:mt-0">
                            Open the
                            <a
                                target="_blank"
                                class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                                href="https://authy.com/download/"
                                >Authenticator App</a
                            >
                            , tap the “+” and scan the image on the left using
                            your phone or tablet.
                        </p>

                        <p class="mt-6 text-sm text-gray-500">
                            <span class="font-medium text-gray-800">Note:</span>
                            Closing this window before entering your security
                            code will require you to rescan your QR code.
                        </p>

                        <p class="mt-6 text-sm text-gray-600">
                            <span class="font-medium text-gray-800"
                                >Manual Entry Key:</span
                            ><br />
                            {{ paringCodes.key }}
                        </p>
                    </div>
                </div>

                <div
                    class="mt-[26px] flex flex-col justify-start pb-5 sm:flex-row"
                >
                    <div class="flex items-center justify-center sm:pl-10">
                        <svg
                            width="70"
                            height="128"
                            viewBox="0 0 70 128"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="2"
                                y="2"
                                width="66"
                                height="124"
                                rx="4"
                                stroke="#6B7280"
                                stroke-width="4"
                            />
                            <path
                                d="M0 6C0 2.68629 2.68629 0 6 0H64C67.3137 0 70 2.68629 70 6V14H0V6Z"
                                fill="#6B7280"
                            />
                            <path
                                d="M70 122C70 125.314 67.4241 128 64.2466 128L5.75343 128C2.5759 128 1.11609e-06 125.314 8.38301e-07 122L0 108L70 108V122Z"
                                fill="#6B7280"
                            />
                            <rect
                                x="22"
                                y="5"
                                width="26"
                                height="4"
                                rx="2"
                                fill="#E5E7EB"
                            />
                            <circle cx="35" cy="118" r="6" fill="#E5E7EB" />
                            <rect
                                x="4"
                                y="14"
                                width="62"
                                height="14"
                                fill="#FFC000"
                            />
                            <rect
                                x="4"
                                y="51"
                                width="62"
                                height="1"
                                fill="#E5E7EB"
                            />
                            <rect
                                x="4"
                                y="73"
                                width="62"
                                height="1"
                                fill="#E5E7EB"
                            />
                            <rect
                                x="4"
                                y="95"
                                width="62"
                                height="1"
                                fill="#E5E7EB"
                            />
                            <path
                                d="M8.90945 46V44.9659L12.1087 41.6513C12.4503 41.2912 12.7319 40.9757 12.9535 40.7049C13.1781 40.431 13.3459 40.1709 13.4567 39.9247C13.5675 39.6785 13.6229 39.4169 13.6229 39.1399C13.6229 38.826 13.549 38.5552 13.4013 38.3274C13.2536 38.0966 13.052 37.9196 12.7965 37.7965C12.5411 37.6703 12.2533 37.6072 11.9332 37.6072C11.5947 37.6072 11.2992 37.6765 11.0469 37.815C10.7945 37.9535 10.6006 38.1489 10.4652 38.4013C10.3298 38.6536 10.2621 38.9491 10.2621 39.2876H8.90021C8.90021 38.7121 9.03255 38.2089 9.29723 37.7781C9.56191 37.3472 9.92507 37.0133 10.3867 36.7763C10.8484 36.5362 11.3731 36.4162 11.9609 36.4162C12.5549 36.4162 13.0781 36.5347 13.5305 36.7717C13.986 37.0056 14.3415 37.3256 14.5969 37.7319C14.8524 38.1351 14.9801 38.5906 14.9801 39.0984C14.9801 39.4492 14.9139 39.7924 14.7816 40.1278C14.6523 40.4633 14.4261 40.8372 14.103 41.2496C13.7798 41.659 13.3305 42.156 12.755 42.7408L10.8761 44.7074V44.7766H15.1325V46H8.90945ZM16.8821 46V44.9659L20.0813 41.6513C20.4229 41.2912 20.7045 40.9757 20.9261 40.7049C21.1508 40.431 21.3185 40.1709 21.4293 39.9247C21.5401 39.6785 21.5955 39.4169 21.5955 39.1399C21.5955 38.826 21.5217 38.5552 21.3739 38.3274C21.2262 38.0966 21.0246 37.9196 20.7692 37.7965C20.5137 37.6703 20.226 37.6072 19.9059 37.6072C19.5674 37.6072 19.2719 37.6765 19.0195 37.815C18.7672 37.9535 18.5733 38.1489 18.4379 38.4013C18.3024 38.6536 18.2347 38.9491 18.2347 39.2876H16.8729C16.8729 38.7121 17.0052 38.2089 17.2699 37.7781C17.5346 37.3472 17.8977 37.0133 18.3594 36.7763C18.821 36.5362 19.3458 36.4162 19.9336 36.4162C20.5276 36.4162 21.0508 36.5347 21.5032 36.7717C21.9587 37.0056 22.3142 37.3256 22.5696 37.7319C22.825 38.1351 22.9528 38.5906 22.9528 39.0984C22.9528 39.4492 22.8866 39.7924 22.7543 40.1278C22.625 40.4633 22.3988 40.8372 22.0756 41.2496C21.7525 41.659 21.3031 42.156 20.7276 42.7408L18.8487 44.7074V44.7766H23.1051V46H16.8821ZM24.8548 46V44.9659L28.054 41.6513C28.3956 41.2912 28.6772 40.9757 28.8988 40.7049C29.1235 40.431 29.2912 40.1709 29.402 39.9247C29.5128 39.6785 29.5682 39.4169 29.5682 39.1399C29.5682 38.826 29.4943 38.5552 29.3466 38.3274C29.1989 38.0966 28.9973 37.9196 28.7418 37.7965C28.4864 37.6703 28.1986 37.6072 27.8786 37.6072C27.54 37.6072 27.2446 37.6765 26.9922 37.815C26.7398 37.9535 26.5459 38.1489 26.4105 38.4013C26.2751 38.6536 26.2074 38.9491 26.2074 39.2876H24.8455C24.8455 38.7121 24.9779 38.2089 25.2425 37.7781C25.5072 37.3472 25.8704 37.0133 26.332 36.7763C26.7937 36.5362 27.3184 36.4162 27.9062 36.4162C28.5002 36.4162 29.0234 36.5347 29.4759 36.7717C29.9313 37.0056 30.2868 37.3256 30.5423 37.7319C30.7977 38.1351 30.9254 38.5906 30.9254 39.0984C30.9254 39.4492 30.8593 39.7924 30.7269 40.1278C30.5977 40.4633 30.3714 40.8372 30.0483 41.2496C29.7251 41.659 29.2758 42.156 28.7003 42.7408L26.8214 44.7074V44.7766H31.0778V46H24.8548ZM37.0238 40.6726V41.8729H32.832V40.6726H37.0238ZM38.4641 46V44.9659L41.6634 41.6513C42.005 41.2912 42.2866 40.9757 42.5082 40.7049C42.7328 40.431 42.9006 40.1709 43.0114 39.9247C43.1222 39.6785 43.1776 39.4169 43.1776 39.1399C43.1776 38.826 43.1037 38.5552 42.956 38.3274C42.8082 38.0966 42.6067 37.9196 42.3512 37.7965C42.0958 37.6703 41.808 37.6072 41.4879 37.6072C41.1494 37.6072 40.8539 37.6765 40.6016 37.815C40.3492 37.9535 40.1553 38.1489 40.0199 38.4013C39.8845 38.6536 39.8168 38.9491 39.8168 39.2876H38.4549C38.4549 38.7121 38.5872 38.2089 38.8519 37.7781C39.1166 37.3472 39.4798 37.0133 39.9414 36.7763C40.4031 36.5362 40.9278 36.4162 41.5156 36.4162C42.1096 36.4162 42.6328 36.5347 43.0852 36.7717C43.5407 37.0056 43.8962 37.3256 44.1516 37.7319C44.4071 38.1351 44.5348 38.5906 44.5348 39.0984C44.5348 39.4492 44.4686 39.7924 44.3363 40.1278C44.207 40.4633 43.9808 40.8372 43.6577 41.2496C43.3345 41.659 42.8852 42.156 42.3097 42.7408L40.4308 44.7074V44.7766H44.6871V46H38.4641ZM49.7283 46.1293C49.0943 46.1293 48.5281 46.02 48.0295 45.8015C47.534 45.583 47.1416 45.2798 46.8523 44.892C46.5661 44.5012 46.4122 44.0488 46.3906 43.5348H47.8402C47.8587 43.8149 47.9525 44.058 48.1218 44.2642C48.2942 44.4673 48.5188 44.6243 48.7958 44.7351C49.0728 44.8459 49.3806 44.9013 49.7191 44.9013C50.0915 44.9013 50.4208 44.8366 50.707 44.7074C50.9963 44.5781 51.2225 44.3981 51.3857 44.1673C51.5488 43.9334 51.6303 43.6641 51.6303 43.3594C51.6303 43.0424 51.5488 42.7638 51.3857 42.5238C51.2256 42.2807 50.9902 42.0898 50.6793 41.9513C50.3716 41.8129 49.9992 41.7436 49.5621 41.7436H48.7635V40.5803H49.5621C49.913 40.5803 50.2208 40.5172 50.4854 40.391C50.7532 40.2648 50.9625 40.0894 51.1133 39.8647C51.2641 39.637 51.3395 39.3707 51.3395 39.0661C51.3395 38.7737 51.2733 38.5198 51.141 38.3043C51.0117 38.0858 50.8271 37.915 50.587 37.7919C50.35 37.6688 50.07 37.6072 49.7468 37.6072C49.439 37.6072 49.1513 37.6642 48.8835 37.7781C48.6188 37.8888 48.4034 38.0489 48.2372 38.2582C48.071 38.4644 47.9818 38.7121 47.9695 39.0014H46.5891C46.6045 38.4905 46.7553 38.0412 47.0415 37.6534C47.3308 37.2656 47.7125 36.9625 48.1864 36.744C48.6604 36.5254 49.1867 36.4162 49.7653 36.4162C50.3716 36.4162 50.8948 36.5347 51.3349 36.7717C51.7781 37.0056 52.1197 37.3179 52.3597 37.7088C52.6029 38.0997 52.7229 38.5275 52.7198 38.9922C52.7229 39.5215 52.5752 39.9709 52.2766 40.3402C51.9812 40.7095 51.5872 40.9573 51.0948 41.0835V41.1573C51.7227 41.2527 52.2089 41.502 52.5536 41.9052C52.9014 42.3084 53.0737 42.8085 53.0707 43.4055C53.0737 43.9257 52.9291 44.3919 52.6367 44.8043C52.3474 45.2167 51.9519 45.5414 51.4503 45.7784C50.9486 46.0123 50.3746 46.1293 49.7283 46.1293ZM54.6172 44.1534V42.9993L58.7028 36.5455H59.6122V38.2443H59.0352L56.1129 42.87V42.9439H61.7127V44.1534H54.6172ZM59.0998 46V43.8026L59.109 43.2763V36.5455H60.4616V46H59.0998Z"
                                fill="#374151"
                            />
                            <rect
                                x="9"
                                y="19"
                                width="30"
                                height="4"
                                fill="#374151"
                            />
                        </svg>
                    </div>
                    <div
                        class="mt-5 flex flex-col items-center justify-center sm:mt-0 sm:items-start sm:pl-16"
                    >
                        <p class="text-base font-medium text-gray-800">
                            Sign in with your security code
                        </p>

                        <TextInput
                            v-model="form.code"
                            class="mt-5 md:max-w-[250px]"
                            placeholder="Security Code"
                            label="Enter the security code to continue"
                            required
                            :error="error"
                        />
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <div class="flex justify-between border-t border-gray-200 p-6">
                <AtomicButton color="white" size="md" @click="closeModal">
                    Cancel
                </AtomicButton>
                <ConfirmsPassword
                    v-if="props.has_password"
                    :force-confirmation="true"
                    @confirmed="confirmTwoFactorAuthentication"
                >
                    <AtomicButton
                        color="yellow"
                        size="md"
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                    >
                        Activate 2FA
                    </AtomicButton>
                </ConfirmsPassword>
                <AtomicButton
                    v-else
                    color="yellow"
                    size="md"
                    :class="{ 'opacity-25': form.processing }"
                    :disabled="form.processing"
                    @click="confirmTwoFactorAuthentication('')"
                >
                    Activate 2FA
                </AtomicButton>
            </div>
        </template>
    </Modal>

    <TwoFactorAuthenticationRecoveryCodesModal
        v-if="recoveryCodes.length !== 0"
        title="Two-Factor Authentication enabled"
        :can-regenerate-codes="false"
        @close="closeModal"
    />
</template>

<script lang="ts" setup>
import { reactive, ref } from 'vue';
import axios from 'axios';
import { route } from 'ziggy-js';
import useParingCodes from '../composable/usePairingCodes';
import ConfirmsPassword from './ConfirmsPassword.vue';

interface modalEmitter {
    (e: 'close'): void;
    (e: 'enabled'): void;
}

const props = defineProps({
    has_password: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits<modalEmitter>();

const { paringCodes } = useParingCodes(
    'auth.prepare-two-factor-authentication'
);

const form = reactive({
    processing: false,
    code: '',
});

const error = ref('');
let confirmingTwoFactorAuthentication = ref(false);
let recoveryCodes = ref<string[]>([]);

const confirmTwoFactorAuthentication = (password: string) => {
    form.processing = true;
    axios
        .post(route('auth.enable-two-factor-authentication'), {
            code: form.code,
            secret: paringCodes.key,
            password: password,
        })
        .then((response) => {
            form.processing = false;
            confirmingTwoFactorAuthentication.value = false;
            if (response.data.data) {
                emit('enabled');
                recoveryCodes.value = response.data.data;
            } else {
                error.value = 'Invalid code';
            }
        })
        .catch((err) => {
            form.processing = false;
            error.value = err.response.data.errors.code[0];
        });
};

const closeModal = () => {
    recoveryCodes.value = [];
    emit('close');
};
</script>
